const defaultNumber = 17;

export const truncateText = (text, length = defaultNumber) => {
  if (text.length < length) {
    return text;
  }

  return text.substring(0, length) + '...';
};
